import * as Styled from './InfoCard.styles';
import MenuListButton from '@innovyze/stylovyze/lib/components/MenuListButton';
import React from 'react';
import ContentCard from '@innovyze/stylovyze/lib/hocs/ContentCard';
import WidgetErrorBoundary from '@innovyze/stylovyze/lib/components/WidgetErrorBoundary';
import InfoCardHeader from './InfoCardHeader';
import { TextOverflow } from '@innovyze/stylovyze/lib/components/TextOverflow';
/**
 * Information card with header and optional menu
 */
export const InfoCard = ({ title, children, menuItems, forceMenu, buttonStyle, fullHeight, errorMessage, dataCy, className, applyBodyPadding, marginBottom, headerProps, titleArea, }) => {
    const header = (React.createElement(InfoCardHeader, { headerProps: headerProps },
        typeof title === 'string' ? (React.createElement(TextOverflow, null, title)) : (title),
        menuItems && menuItems.length === 1 && !forceMenu && (React.createElement(Styled.MenuSingleButton, { ...menuItems[0].props, onClick: menuItems[0].onClick, variant: buttonStyle?.variant, color: buttonStyle?.color, "data-cy": menuItems[0].cy },
            menuItems[0].icon,
            menuItems[0].text)),
        menuItems && (menuItems.length > 1 || forceMenu) && (React.createElement(MenuListButton, { menuItems: menuItems })),
        menuItems == undefined && titleArea && React.createElement(React.Fragment, null, titleArea)));
    const body = (React.createElement(WidgetErrorBoundary, { errorMessage: errorMessage }, children));
    return (React.createElement(ContentCard, { header: header, applyHeaderDivider: true, applyBodyPadding: applyBodyPadding, fullHeight: fullHeight, applyMarginBottom: marginBottom, className: className, dataCy: dataCy }, body));
};
InfoCard.defaultProps = {
    applyBodyPadding: true,
};
export default React.memo(InfoCard);
